export default __webpack_public_path__ + "static/media/img_5.54086b8c.jpeg";